<template>
  <el-container height="auto">
 
    <el-main>
        
              <el-form ref="form" :model="form"  :rules="rules" label-width="100px">

                <el-row >
                    <el-col :span="11">
                      <el-form-item label="姓名" prop="subjectname">
                        <el-input v-model="form.subjectname"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2"></el-col>
                    <el-col :span="11">
                      <el-form-item label="电话" prop="phone">
                        <el-input v-model="form.phone"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row >
                    <el-col :span="11">
                      <el-form-item label="姓名缩写" >
                        <el-input v-model="form.initials"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2"></el-col>
                    <el-col :span="11">
                      <el-form-item label="编号" prop="subjectnumber">
                        <el-input v-model="form.subjectnumber"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row >
                    <el-col :span="11">
                      <el-form-item label="身份证号码" >
                        <el-input v-model="form.personalid"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2"></el-col>
                    <el-col :span="11">
                    
                    </el-col>
                  </el-row>

                  <el-row >
                    <el-col :span="11">

                      <el-form-item label="性别">
                        <el-radio-group v-model="form.sex" size="medium">
                          <el-radio-button label="M">男</el-radio-button>
                          <el-radio-button label="F">女</el-radio-button>
                          <el-radio-button label="U">未知</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                    
                    </el-col>
                    <el-col class="line" :span="2"></el-col>
                    <el-col :span="11">
                      <el-form-item label="出生日期" >
                        <el-date-picker type="date" placeholder="选择日期" v-model="form.dob" style="width: 100%;"></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="标签" >
                    <!-- <el-input v-model="form.category" autocomplete="off"></el-input> -->
                    <div v-if="form.category ||'' !=''">
                      <el-tag
                        :key="tag"
                        v-for="tag in form.category.split(',')"
                        closable
                        :disable-transitions="false"
                        @close="handleTagClose(tag)">
                        {{tag}}
                      </el-tag>
                    </div>
                    <el-input
                      v-if="tag.inputvisiable"
                      v-model="tag.inputvalue"
                      ref="saveTagInput"
                      size="small"
                      style="width:90px;"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button v-else icon="el-icon-plus" size="small" @click="showTagInput">增加标签</el-button>

                  </el-form-item>
                  <el-form-item label="备注" >
                        <el-input type="textarea" v-model="form.comments" autosize></el-input>
                      </el-form-item>

                  <el-form-item style="text-align:center">
                    <el-button type="primary" @click="onSave">保存</el-button>
                    <el-button type="danger" @click="delSubject">删除</el-button>
                  </el-form-item>
                  
                </el-form>
    </el-main>

  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        subjectid: this.$route.query.id,
        form: {
          subjectname: '',
          initials: '',
          sex: '',
          dob: '',
          category:'',
          comments: '',
          personalid:'',
          phone:'',
          subjectnumber:''
        },
        rules: {
          subjectname: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ]
        },
        tag:{
          inputvisiable:false,
          inputvalue:'',
        }
      };
    },
    mounted(){
      this.getsubjectinfo(this.subjectid);

    },
    methods: {
      onSave(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
              this.$http.post("subject/edit",this.form).then((res) => { 
                if(!res) return;
                //提醒成功
                this.$message({ type:'success', message:'病例编辑成功'})
               
              });
          }
          
        });
      },
      delSubject(){
        this.$confirm("确定要删除病例吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post("subject/delete",{subjectid:this.subjectid}).then((res) => { 
                if(!res) return;

                  this.$router.push({name:"home-subject"});
               
                });
            }, ()=>{});
      },
      getsubjectinfo(subjectid){
        this.$http.get('subject/info',
        {
          params:{subjectid:subjectid}
        })
        .then((res) => { 
          this.form = Object.assign(this.form,res.data.info);
        });
      },
      showTagInput(){
        this.tag.inputvisiable = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm(){
        let inputValue = this.tag.inputvalue;
        if (inputValue) {
          if(this.form.category||'' != '') this.form.category += ","
          this.form.category += inputValue;
        }
        this.tag.inputvisiable = false;
        this.tag.inputvalue = '';
      },
      handleTagClose(tag){
        
        let arrycategory = this.form.category.split(',');        
        arrycategory.splice(arrycategory.indexOf(tag), 1);
        this.form.category = arrycategory.join(",");
      },
      


    }
  }
</script>
<style scoped>
</style>